import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loan-table',
  templateUrl: './loan-table.component.html',
  styleUrls: ['./loan-table.component.scss']
})
export class LoanTableComponent implements OnInit {

  constructor() { }
  @Input() header:any = [{
    label: 'SHG Member Name',
    key: 'memberName'
  },{
    label:'Father / Husband Name',
    key:'belongingName'
  },{
    label:'Gender',
    key:'gender'
  },{
    label:'Signature/Thumb impression',
    key:'signature'
  }];

 @Input() tableData:any = [{
    memberName : 'RAJKUMARI AHIRWAR',
    fatherName : 'RAJA AHIRWAR',
    gender : 'M',
    signature : ''
  },
  {
    memberName : 'RAJKUMARI AHIRWAR',
    fatherName : 'RAJA AHIRWAR',
    gender : 'M',
    signature : ''
  },
  {
    memberName : 'RAJKUMARI AHIRWAR',
    fatherName : 'RAJA AHIRWAR',
    gender : 'M',
    signature : ''
  },];

  loanType: any = {1: 'Cash Credit Loan', 2: 'Term Loan'};
  ngOnInit(): void {
    // console.log("table", this.tableData, this.header)
  }

}
